import { useSelector } from 'react-redux'
import { Bar, Cell } from 'recharts'
import { CalculateSize } from '../../../../../../../common/CalculateSize'
import { ChartContainer } from '../../../../../../../common/chart/chartContainer'
import { MARGIN_CHART } from '../../../../../../../common/chart/chartContainer/constants'
import { Loading } from '../../../../../../../common/loading'
import { Notification } from '../../../../../../../common/notification'
import { SCREEN } from '../../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { formatText } from '../../../../../../../helpers/value'
import { formatDataChartIndustry } from '../../../helpers'
import { selectIsLoading, selectRawData, selectYear } from '../../store/slice'

export const ChartPriceFDI = ({ yAxisWidth, height }) => {
  const { formatCurrency, formatCurrencyWithUnit } = useFormatCurrency(
    SCREEN.INDUSTRY_OVERVIEW,
  )

  const year = useSelector(selectYear)
  const data = useSelector(selectRawData)
  const isLoading = useSelector(selectIsLoading)

  const chartData = formatDataChartIndustry(data, year)

  if (isLoading) {
    return (
      <div className="h100 positionRelative">
        <Loading />
      </div>
    )
  }

  if (!chartData.length) {
    return <Notification />
  }

  return (
    <div className="h100 positionRelative">
      <CalculateSize height="100%">
        {(size) => {
          return (
            <ChartContainer
              key={chartData.length}
              margin={{ ...MARGIN_CHART, right: 50, bottom: 0 }}
              data={chartData}
              width={'100%'}
              height={height || size.height}
              layout="vertical"
              cartesianGrid={{ vertical: true, horizontal: false }}
              yAxis={[
                {
                  width: yAxisWidth || 280,
                  dataKey: 'name',
                  yAxisId: 'left',
                  type: 'category',
                  tickStyle: (name) => {
                    const item =
                      chartData.find((item) => item.name === name) || {}

                    return {
                      color: item.isMain ? '#006AA6' : '#3A414B',
                      fontWeight: item.isMain ? 600 : 400,
                    }
                  },
                  tickFormatter: (name) => formatText(name),
                  lineClamp: 1,
                },
              ]}
              xAxis={[
                {
                  type: 'number',
                  dataKeys: ['value'],
                  isStackedBar: true,
                  tickFormatter: (value) =>
                    formatCurrency({
                      value,
                      year,
                      exchangeRateType: 'averageRate',
                    }),
                },
              ]}
              tooltip={{
                maxWidth: 300,
                schema: {
                  content: [
                    {
                      dataKey: 'value',
                      label: 'industryOverview.macroeconomics.VALUE',
                      isI18n: true,
                      formatValue: (value) =>
                        formatCurrencyWithUnit({
                          value,
                          year,
                          exchangeRateType: 'averageRate',
                        }),
                    },
                  ],
                },
              }}
            >
              <Bar
                yAxisId={'left'}
                dataKey={'value'}
                barSize={15}
                fill="#E5E5E8"
                isAnimationActive={false}
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.isMain ? '#006AA6' : '#E5E5E8'}
                    isAnimationActive={false}
                  />
                ))}
              </Bar>
            </ChartContainer>
          )
        }}
      </CalculateSize>
    </div>
  )
}
